import { useQuery } from "@tanstack/react-query";

import { GetReviewCycleLogsFrontendResponse } from "@performyard/service-contracts";

import { reviewCycleLogsQuery } from "../../queries";
import { GetReviewCycleLogsParams } from "../../services/internal-api/review-cycle-logs";
import { PYUseQueryOptions } from "../StandardQueryArguments";

export const useReviewCycleLogs = (
	{ resourceTypes, resourceIds, changeTypes, subjectIds, limit, skip, sort }: GetReviewCycleLogsParams,
	options?: PYUseQueryOptions<GetReviewCycleLogsFrontendResponse>
) => {
	const query = useQuery<GetReviewCycleLogsFrontendResponse>({
		...reviewCycleLogsQuery({ resourceTypes, resourceIds, changeTypes, subjectIds, limit, skip, sort }),
		...options,
	});

	return {
		reviewCycleLogs: query?.data?.results || [],
		totalCount: query?.data?.total || 0,
		isLoading: query?.isLoading,
	};
};
